<template>
  <div class="upload">
    <div class="upload_head">
      <div class="upload_logo"></div>
    </div>
    <div class="upload_main">
      <div class="upload_main_box">
        <div class="upload_main_title">请上传需匹配的会员卡照片（正反面）或信息截图</div>
        <div class="upload_main_list">
          <van-uploader  v-model="fileList1" :after-read="afterRead1" :max-count="1" >
            <div class="upload_main_icon">
              <img src="../assets/imgs/MSC-H5-0916_07.png">
            </div>
          </van-uploader>
          <van-uploader  v-model="fileList2" :after-read="afterRead2" :max-count="1" >
            <div class="upload_main_icon">
              <img src="../assets/imgs/MSC-H5-0916_07.png">
            </div>
          </van-uploader>
          <!--<van-uploader v-model="fileList" :after-read="afterRead"  :max-count="1" />
            <div class="upload_main_icon"></div>
          </van-uploader>
          <van-uploader v-model="fileList" :after-read="afterRead"  :max-count="1" />
            <div class="upload_main_icon"></div>
          </van-uploader>-->
        </div>
        <div class="upload_main_tip">提示：“需包含会员姓名和等级”（可上传最多2张照片）</div>
      </div>
    </div>
    <div class="upload_foot">
      <div class="upload_foot_bg">
        <div class="btn submit" @click="onSubmit">上传</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { dateFormat , uploadOss , getSession , setSession } from "@/util/util"
  export default {
    name: 'upload',
    data () {
      return {
        fileList1:[],
        fileList2:[],
        url1:"",
        url2:"",
        sub:true,
      }
    },
    created(){
        
    },
    mounted(){
    },
    methods: {
      afterRead1(file) {
        uploadOss(file.file,(url) => {
          console.log(url);
          this.url1 = url;
        })
      },
      afterRead2(file) {
        uploadOss(file.file,(url) => {
          console.log(url);
          this.url2 = url;
        })
      },
      onSubmit(){
        if(this.sub){
          let loadingToast = Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner'
          });
          setTimeout(()=>{
            let { url1 , url2 } = this;
            if(!url1 && !url2){
              Toast('最少上传一张图片');
              return;
            }
            // Toast(url1);
            // Toast(url2);
            this.sub = true;
            setSession("url1",url1);
            setSession("url2",url2);
						loadingToast.clear();
            this.$router.back(-1);
          },1000);
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/upload.vue